module.exports = __webpack_public_path__ + "static/img/product-poster-6.c0942ea8.png";